export default function CDefaultParameters() {
  return <h2>C Default Parameters</h2>;
}
